import { number, object, ObjectSchema, string } from 'yup';

import { RemitFinancialInfo } from '@/types/billing';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

export const RemitFinancialInformationSchema: ObjectSchema<
  Omit<RemitFinancialInfo, 'id' | 'remit_id' | 'potential_duplicates' | 'amount_difference'>
> = object().shape({
  check_amount: string().max(100).required().transform(transformEmptyStringToNull),
  check_amount_in_cents: number().integer().min(-2147483648).max(2147483647).nullable(),
  check_or_eft_trace_number: string().max(100).required().transform(transformEmptyStringToNull),
  paid_at: string().required(),
  payment_method: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_identifier: string().max(100).nullable().transform(transformEmptyStringToNull),
  originating_company_co_supplemental_code: string()
    .max(100)
    .nullable()
    .transform(transformEmptyStringToNull),
  routing_number: string().max(50).nullable().transform(transformEmptyStringToNull),
  transaction_set_control_no: string().max(100).nullable().transform(transformEmptyStringToNull),
  transaction_set_identifier_code: string()
    .max(50)
    .nullable()
    .transform(transformEmptyStringToNull),
  payer_name: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_address_line1: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_address_line2: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_city: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_state: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_zip: string().max(50).nullable().transform(transformEmptyStringToNull),
  payer_country: string().max(50).nullable().transform(transformEmptyStringToNull),
  other_payer_identifier: string().max(50).nullable().transform(transformEmptyStringToNull)
});
